/** @jsx jsx */
import { h, Fragment, Component } from "preact";
import { observer } from "mobx-react";
import { useMemo } from 'preact/hooks';
import { jsx, css } from '@emotion/react';

import { filters } from '@searchspring/snap-toolbox';

import { SortBy } from "./SortBy";
import { SidebarContents } from "../Sidebar/Sidebar";
import { MediaQuery } from '../Helpers/MediaQuery'
import { FacetOptionsFooter } from './FacetDisplays'
import { FilterSummary } from "../FilterSummary/FilterSummary";

import {
  Button,
  Facet,
  FacetSlider,
  FacetGridOptions,
  FacetPaletteOptions,
  FacetListOptions,
  FacetHierarchyOptions,
  Slideout,
  withStore,
} from "@searchspring/snap-preact-components";

import { IconClose } from '../Icons/IconClose'

import './toolbar.css'

@withStore
@observer
export class Toolbar extends Component {
  constructor(props) {
    super(props)
    this.state = {
        activeKey: null,
        showViewResultsButton: false,
    }

    this.setActiveKey = this.setActiveKey.bind(this)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.preventPropagation = this.preventPropagation.bind(this)
    this.handleCloseSidebar = this.handleCloseSidebar.bind(this)
  }

  handleCloseSidebar() {
    const mobileFiltersButton = document.querySelector('.ss__slideout__button')
    mobileFiltersButton.click()
  }

  setActiveKey(value) {
    this.setState({
        activeKey: value,
    })
  }

  preventPropagation(e) {
      e.stopPropagation()
  }

  handleOutsideClick() {
      this.setState({
          activeKey: null,
      })
  }

  componentDidMount() {
    this.props.store.facets.forEach(facet => {
        facet.collapsed = true
    })

    const toolbar = document.getElementById('toolbar-filters')
    const body = document.body
    const sticky = toolbar.offsetTop

    /* Handle sticky header */
    const toggle = () => {
        if (window.pageYOffset + 100 > sticky) {
            toolbar.classList.add('sticky')
            body.classList.add('show-header')
        } else {
            toolbar.classList.remove('sticky')
            body.classList.remove('show-header')
        }
    }
    window.onscroll = () => toggle()

    /* Handle outside click */
    toolbar.addEventListener('click', this.preventPropagation)
    window.addEventListener('click', this.handleOutsideClick)
  }

  componentWillUnmount() {
      /*Clean up event handlers */
      const toolbar = document.getElementById('toolbar-filters')
      toolbar.removeEventListener('click', this.preventPropagation)
      window.removeEventListener('click', this.handleOutsideClick)
  }
  render() {
    const {
      facets,
      filters,
    } = this.props.store;

    const inlineCount = this.props.store.merchandising?.content?.inline?.length ?? 0
    const resultCount = this.props.store.pagination.totalResults - inlineCount

    let leftColumnLayout = ""

    if(window.Resources.searchspring.toolbar.leftColumnLayout == 'false') {
      leftColumnLayout = ""
    } else {
      leftColumnLayout = window.Resources.searchspring.toolbar.leftColumnLayout;
    }

    return (
      <div class="ss-toolbar ss-toolbar-top page-width" id="toolbar-filters"
      >
        <div class={ leftColumnLayout ? ("toolbar-wrapper left-column-sticky") : ("toolbar-wrapper") }>
          <MediaQuery query="(max-width: 989px)">
            <div class="ss-toolbar-row">
              <div class="ss-toolbar-col">
                <SortBy />
              </div>
            </div>

            <Slideout
              buttonContent={slideoutButton(filters)}
            >
              <Fragment>
                <div className={`slideout-content-wrapper slideout-filter-by${filters.length ? ' filtered' : ''}`}>
                  <h3 className="eyebrow eyebrow--small">{window.Shopify.locale === "es" ? "Filtrar" : "Filter" }</h3>
                  <span className="slideout-close-button" onClick={this.handleCloseSidebar}>
                    <IconClose />
                  </span>
                  <FilterSummary clearAllLabel={window.Shopify.locale === "es" ? "Borrar todo" : "Clear All" } />
                </div>
                <SidebarContents />
              </Fragment>

              <div class={
                  this.state.showViewResultsButton
                      ? 'slideout-view-results slideout-view-results--active'
                      : 'slideout-view-results'
                  }
              >
                <button class="CQL-p2 button button--primary" onClick={this.handleCloseSidebar}>{window.Resources.searchspring.recommendations.filterSeeResults} ({resultCount})</button>
              </div>
            </Slideout>
          </MediaQuery>

          <MediaQuery query="(min-width: 990px)">
            { leftColumnLayout ? (
              <div class="ss-toolbar-row">
                <div class="ss-toolbar-row">
                  <div class="ss-toolbar-col">
                    <SortBy />
                  </div>
                </div>
            </div>
            ) : (
              <div class="ss-toolbar-row">
                <div class="ss-toolbar-row">
                  <div class="ss-toolbar-col">
                    <SortBy />
                  </div>
                </div>

                <Slideout buttonContent={slideoutButton(filters)}>
                  <Fragment>
                    <div className={`slideout-content-wrapper slideout-filter-by${filters.length ? ' filtered' : ''}`}>
                      <h3 class="CQL-h3 eyebrow eyebrow--small">{window.Shopify.locale === "es" ? "Filtrar" : "Filter" }</h3>
                      <span className="slideout-close-button" onClick={this.handleCloseSidebar}>
                        <IconClose />
                      </span>
                    </div>
                    <SidebarContents />
                  </Fragment>

                  <div class={
                    this.state.showViewResultsButton
                        ? 'slideout-view-results slideout-view-results--active'
                        : 'slideout-view-results'
                    }
                  >
                    <button class="button button--primary CQL-p2" onClick={this.handleCloseSidebar}>{window.Resources.searchspring.recommendations.filterSeeResults} ({resultCount})</button>
                  </div>
                </Slideout>
            </div>
            )
            }
          </MediaQuery>
        </div>
      </div>
    );
  }
}

const slideoutButton = (filters) => {
  let filtersApplied = filters.length > 0 ? `(${filters.length})` : null;

  return (
    <Button
      style={{
        margin: "0 1rem",
        display: "block",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "center",
      }}
    >

      {window.Resources.searchspring.toolbar.filter} <span className="ss__filters-applied">{filtersApplied}</span>
      <svg className="filter-icon" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icon_slider-line">
      <path id="Shape" fill-rule="evenodd" clip-rule="evenodd" d="M5.91652 5.44659C6.95032 5.7135 7.67106 6.64806 7.66652 7.71575C7.67106 8.78344 6.95032 9.718 5.91652 9.98492V18.5833C5.91652 18.9054 5.65535 19.1666 5.33319 19.1666C5.01102 19.1666 4.74985 18.9054 4.74985 18.5833V9.98492C3.70021 9.73354 2.95996 8.79508 2.95996 7.71575C2.95996 6.63643 3.70021 5.69796 4.74985 5.44659V3.41659C4.74985 3.09442 5.01102 2.83325 5.33319 2.83325C5.65535 2.83325 5.91652 3.09442 5.91652 3.41659V5.44659ZM4.16652 7.71575C4.16652 8.36008 4.68886 8.88242 5.33319 8.88242V8.89992C5.64566 8.89995 5.94509 8.77464 6.16439 8.55205C6.3837 8.32945 6.50454 8.02819 6.49985 7.71575C6.49985 7.07142 5.97752 6.54909 5.33319 6.54909C4.68886 6.54909 4.16652 7.07142 4.16652 7.71575Z" fill="black"/>
      <path id="Shape_2" fill-rule="evenodd" clip-rule="evenodd" d="M17.5835 7.46492C18.6173 7.73183 19.3381 8.6664 19.3335 9.73409C19.3381 10.8018 18.6173 11.7363 17.5835 12.0033V18.5833C17.5835 18.9054 17.3223 19.1666 17.0002 19.1666C16.678 19.1666 16.4168 18.9054 16.4168 18.5833V12.0033C15.3672 11.7519 14.627 10.8134 14.627 9.73409C14.627 8.65476 15.3672 7.7163 16.4168 7.46492V3.41659C16.4168 3.09442 16.678 2.83325 17.0002 2.83325C17.3223 2.83325 17.5835 3.09442 17.5835 3.41659V7.46492ZM15.8335 9.73409C15.8335 10.3784 16.3558 10.9008 17.0002 10.9008V10.9241C17.3137 10.9241 17.614 10.798 17.8335 10.5742C18.053 10.3503 18.1731 10.0475 18.1668 9.73409C18.1668 9.08975 17.6445 8.56742 17.0002 8.56742C16.3558 8.56742 15.8335 9.08975 15.8335 9.73409Z" fill="black"/>
      <path id="Shape_3" fill-rule="evenodd" clip-rule="evenodd" d="M11.7505 12.5224C12.7843 12.7893 13.505 13.7239 13.5005 14.7916C13.505 15.8593 12.7843 16.7938 11.7505 17.0608V18.5833C11.7505 18.9054 11.4893 19.1666 11.1672 19.1666C10.845 19.1666 10.5838 18.9054 10.5838 18.5833V17.0608C9.53419 16.8094 8.79395 15.8709 8.79395 14.7916C8.79395 13.7123 9.53419 12.7738 10.5838 12.5224V3.41659C10.5838 3.09442 10.845 2.83325 11.1672 2.83325C11.4893 2.83325 11.7505 3.09442 11.7505 3.41659V12.5224ZM10.0005 14.7916C10.0005 15.4359 10.5228 15.9583 11.1672 15.9583V15.9758C11.4796 15.9758 11.7791 15.8505 11.9984 15.6279C12.2177 15.4053 12.3385 15.104 12.3338 14.7916C12.3338 14.1473 11.8115 13.6249 11.1672 13.6249C10.5228 13.6249 10.0005 14.1473 10.0005 14.7916Z" fill="black"/>
      </g>
      </svg>
    </Button>
  );
};

class ControlledFacet extends Component {
  constructor(props) {
      super(props)
      this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
      const { facet, activeKey, setActiveKey } = this.props
      setActiveKey(activeKey === facet.field ? null : facet.field)
  }

  render({ facet, activeKey, setActiveKey, className }) {
      if (facet.field === activeKey) {
        className += 'selected-facet'
      } else {
        facet.collapsed = true
      }

      let showFacet = true

      return showFacet ? (
        <div class={className} onClick={this.handleClick}>
          <Facet
              facet={facet}
              disableOverflow={true}
              optionsSlot={<OptionsSlot setActiveKey={setActiveKey} />}
          />
        </div>
      ) : null
  }
}

export class OptionsSlot extends Component {
  constructor(props) {
      super(props)
      this.handleClick = this.handleClick.bind(this)
      this.handleClose = this.handleClose.bind(this)
  }

  handleClick(e) {
      e.stopPropagation()
  }

  handleClose() {
      const { setActiveKey } = this.props
      setActiveKey(null)
  }

  getFacetDisplay(facet) {
      switch (facet.display) {
        case 'slider':
          return <FacetSlider facet={facet} />
        case 'grid':
          let columns = facet.label == "Size" ? 8 : 6
          return <FacetGridOptions facet={facet} values={facet.values} columns={8} />
        case 'palette':
          return <CustomFacetPaletteOptions facet={facet} />;
        case 'hierarchy':
          return <FacetHierarchyOptions values={facet.values} />
        default:
          return <FacetListOptions values={facet.values} />
      }
  }

  render({ facet }) {
      const facetDisplay = this.getFacetDisplay(facet)

      return (
          <div onClick={this.handleClick}>
              {facetDisplay}
              <FacetOptionsFooter onClose={this.handleClose} />
          </div>
      )
  }
}

const CustomFacetPaletteOptions = ({ facet }) => {
  const { values } = facet;
  const { field } = facet
  const shopifyFileURL = window.Resources.searchspring.shopifyURLs.fileURL.split('/placeholder')[0];

  const transformedValues = useMemo(() => {
    return values.filter(v => v.label);
  }, [values]);

  const facetCss = useMemo(() => {
    const styles = {};

    transformedValues.forEach(v => {
      let filterLabel = v.label.replaceAll(' ', '-').toLowerCase();
      let filterImage = shopifyFileURL + "/" + field + "__" + filterLabel + ".png";
      let background = `url("${filterImage}")`;

      styles[`& .ss__facet-palette-options__option__palette--${filters.handleize(filterLabel)}`] = {
        display: 'block',
        background: background,
      };
    });

    return [css(styles)];
  }, [transformedValues]);

  return <FacetPaletteOptions css={facetCss} values={transformedValues} columns={12} hideIcon gapSize='0px' />;
};